<div class="flex flex-row min-w-0 min-h-0 h-full overflow-hidden">
  <app-dashboard-nav />

  <div class="flex-1 h-full min-h-0 min-w-0 flex flex-col overflow-y-auto">
    <div class="px-7 py-2 flex-1 position-relative">
      <router-outlet />

      @if (isRouteLoading()) {
        <div class="position-absolute top-0 left-0 flex-content-center w-full h-full bg-bg">
          <app-loading-indicator mode="centered" />
        </div>
      }
    </div>

    <app-footer />
  </div>
</div>

